import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import StyledFormOptionLabel from '../../form-option/styles/form-option.label.styles';
import StyledFormOptionTextLabel from '../../form-option/styles/form-option.label-text.styles';
import { getResetByTag } from '../../../styles';
var innerStyles = /*#__PURE__*/css("align-items:flex-start;display:flex;flex-direction:column;", StyledFormOptionTextLabel, "{display:flex;}", StyledFormOptionLabel, "{align-items:center;}" + (process.env.NODE_ENV === "production" ? "" : ";label:innerStyles;"));
var resetStyles = getResetByTag('div');
var StyledTileInner = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "e1pgfwvl0"
} : {
  target: "e1pgfwvl0",
  label: "StyledTileInner"
})(resetStyles, innerStyles);
export default StyledTileInner;